import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DataListInput } from '@components/DataListInput';
import { DateFilterValue, DateTimeRange } from '@components/DateTimeRange';
import { ErrorModal } from '@components/Modal/presets';

import { DateTimeType } from '@utils/dateTimeFormatter';

import styles from '../Table.module.scss';
import { useTableContext } from '../TableContext';
import { filter } from '../TableService';

const languageNamespace = 'table';

export const TableHeaderDateFilterKey = '_headerDateFilter';

export interface TableDateSectionProps {
  dateTimeType: DateTimeType;
  disableFuture?: boolean;
  isValid?: (dateToCheck: DateFilterValue) => boolean;
  errorCode?: string;
  errorMessage?: string | string[];
}

export const TableDateSection = ({
  dateTimeType,
  disableFuture,
  isValid,
  errorCode,
  errorMessage,
}: TableDateSectionProps) => {
  const { columnFilterState } = useTableContext();

  const { t } = useTranslation(languageNamespace);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleChange = (newDate: DateFilterValue) => {
    if (!isValid || isValid(newDate)) {
      filter?.(TableHeaderDateFilterKey, newDate);
    } else {
      setShowErrorModal(true);
    }
  };

  const value = columnFilterState?.get(TableHeaderDateFilterKey) as DateFilterValue;

  return (
    <div className={styles.dateSection}>
      <div>
        <span className={styles.dateSectionTitle}>{t('dateAndTimeRange')}</span>
        <DateTimeRange
          value={value}
          onChange={handleChange}
          type={dateTimeType}
          disableFuture={disableFuture}
        />
      </div>
      <div>
        <span className={styles.dateSectionTitle}>{t('monthlyBalance/weeklyBalance')}</span>
        <div className={styles.mbWbFilters}>
          <DataListInput placeholder={t('financialYear')} disabled />
          <DataListInput placeholder={t('mbNumber')} disabled />
          <DataListInput placeholder={t('wbNumber')} disabled />
        </div>
      </div>
      {showErrorModal && (
        <ErrorModal
          messages={errorMessage || t('invalidDateMessage')}
          errorCode={errorCode}
          onClick={() => {
            setShowErrorModal(false);
          }}
        />
      )}
    </div>
  );
};
